import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=7f6b13f5&scoped=true"
import script from "./SectionEditor.vue?vue&type=script&lang=ts"
export * from "./SectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./SectionEditor.vue?vue&type=style&index=0&id=7f6b13f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b13f5",
  null
  
)

export default component.exports